import React from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'

import Tooltip from '../../../Tooltip/Tooltip.jsx'
import {
  getMutualFundTooltipContent,
  getTooltipContentByKey,
} from '../../../Tooltip/tooltipUtil'

function RatingsRiskRiskMeasures({ risk, renderRiskReturn }) {
  const mutualFundTooltipData = getMutualFundTooltipContent()

  return (
    <div className="Content" id="risk-three-year">
      <div className="Grid Grid--alignMiddle u-marginBottom3gu">
        <div className="Content u-sizeFill">
          <h3 className="u-margin0">
            Risk Measures
            <span> as of {formatDateStandard(risk.riskEffectiveDate)} </span>
          </h3>
        </div>
        <div className="u-sizeFit">
          <a
            className="js-subnav-link Link u-textSecondary u-textSolid"
            href="#definitions"
          >
            View definitions
          </a>
        </div>
      </div>
      <div className="Grid Grid--alignBottom Grid--withGutter">
        {risk.risks.map((measure) => {
          return (
            <div
              key={measure.description}
              className={`u-paddingVert2gu ${
                renderRiskReturn || risk.risks.length < 4
                  ? 'u-size2of6'
                  : 'u-size1of5'
              } u-sm-posRelative`}
            >
              {getTooltipContentByKey(
                mutualFundTooltipData,
                measure.description
              )?.heading ||
              getTooltipContentByKey(mutualFundTooltipData, measure.description)
                ?.content ? (
                <Tooltip
                  heading={
                    getTooltipContentByKey(
                      mutualFundTooltipData,
                      measure.description
                    )?.heading || ''
                  }
                  content={
                    getTooltipContentByKey(
                      mutualFundTooltipData,
                      measure.description
                    )?.content || ''
                  }
                  direction="Tooltip-left"
                  id={`tooltip-${measure.description}`}
                >
                  <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                    <span className="u-textColorLight u-textSecondary Tooltip-label">
                      {measure.description}
                    </span>
                    <span className="Icon--material Tooltip-icon u-marginLeft1gu u-inline">
                      info
                    </span>
                  </p>
                </Tooltip>
              ) : (
                <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                  {measure.description}
                </p>
              )}
              <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-textDefault">
                {measure.value}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default RatingsRiskRiskMeasures
